<template>
  <div>
    <section class="event pricing set-relative bg">
      <div class="container" style="margin-bottom:0px">
        <div class="">
          <div class="col-12">
            <div class="owl-carousel owl-theme pricing-slider owl-loaded owl-drag" >
              <div class="owl-stage-outer">
                <div class="owl-stage flex-wrap flex-row p-2" style="display: flex;">
                  <div class="owl-item active col-12 col-xl-5 col-lg-8 col-md-12 col-sm-12 col-xs-12 mx-auto text-center">
                    <div class="item">
                      <div class="price-container shadows bg-white text-center">
                        <div class="price-feature-container set-relative">
                          <div class="feature-text">
                            <h4 class="feature-text-heading bold text-uppercase font-primary">HSC</h4>
                            <hr class="set-border" style="margin-bottom: 1rem;margin-top: 0.6rem;">
                          </div>
                          <div class="price-features font-primary">
                            <h6 class="price text-center-feature">
                              Board : {{academic.hsc_board}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Roll No. : {{academic.hsc_roll}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Reg No. : {{academic.hsc_reg}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Group : {{academic.hsc_group}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Year : {{academic.hsc_year}}
                            </h6>
                          </div>
                          <div class="price-value" style="margin-bottom:0px">
                            <h6 class="price text-center font-primary">
                              <span class="large font-primary" style="font-size:40px">
                                GPA : {{academic.hsc_gpa}}
                              </span>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="owl-item active col-12 col-xl-5 col-lg-8 col-md-12 col-sm-12 col-xs-12 mx-auto text-center">
                    <div class="item">
                      <div class="price-container shadows bg-white text-center">
                        <div class="price-feature-container set-relative">
                          <div class="feature-text">
                            <h4 class="feature-text-heading bold text-uppercase font-primary">SSC</h4>
                            <hr class="set-border" style="margin-bottom: 1rem;margin-top: 0.6rem;">
                          </div>
                          <div class="price-features font-primary">
                            <h6 class="price text-center-feature">
                              Board : {{academic.ssc_board}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Roll No. : {{academic.ssc_roll}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Reg No. : {{academic.ssc_reg}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Group : {{academic.ssc_group}}
                            </h6>
                            <h6 class="price text-center-feature">
                              Year : {{academic.ssc_year}}
                            </h6>
                          </div>
                          <div class="price-value" style="margin-bottom:0px">
                            <h6 class="price text-center font-primary">
                              <span class="large font-primary" style="font-size:40px">
                                GPA : {{academic.ssc_gpa}}
                              </span>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>    
        </div>
          
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import { GET_STUDENT_PROFILE_ACADEMIC } from '../../const/api'
import { GET } from '../../utils/Request'

export default {
  name: 'ProfileAcademicInfo',
  components: { Loader },
  data() {
    return {
      academic:{
        hsc_board: "",
        hsc_gpa: "",
        hsc_group: "",
        hsc_reg: "",
        hsc_roll: "",
        hsc_year: "",
        ssc_board: "",
        ssc_gpa: "",
        ssc_group: "",
        ssc_reg: "",
        ssc_roll: "",
        ssc_year: ""
      },
    }
  },
  created() {
    this.getAcademicInfo();
  },
  
  methods: {
    async getAcademicInfo(){
      var data = await GET(GET_STUDENT_PROFILE_ACADEMIC);
      this.academic.hsc_board = data.data.data.hsc_board;
      this.academic.hsc_gpa = data.data.data.hsc_gpa;
      this.academic.hsc_group = data.data.data.hsc_group;
      this.academic.hsc_reg = data.data.data.hsc_reg;
      this.academic.hsc_roll = data.data.data.hsc_roll;
      this.academic.hsc_year = data.data.data.hsc_year;

      this.academic.ssc_board = data.data.data.ssc_board;
      this.academic.ssc_gpa = data.data.data.ssc_gpa;
      this.academic.ssc_group = data.data.data.ssc_group;
      this.academic.ssc_reg = data.data.data.ssc_reg;
      this.academic.ssc_roll = data.data.data.ssc_roll;
      this.academic.ssc_year = data.data.data.ssc_year;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 20%;
}
.d-flex{
  padding:10px;
  /* -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3; */
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}
.flower-spinner{
  margin: auto;
}
.owl-item{
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
  border-radius: 10px;
  padding: 0px;
  margin: 10px;
}
</style>
